module.exports = __webpack_public_path__ + "fail_send.png?81cfde2464be4566b503376e05fcce7f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fail_send.png
// module id = 29
// module chunks = 0